<template>
	<v-card
		class="app-company-no-license-card mx-auto"
	>
		<v-img
			height="280px"
			src="/images/image-no-license.jpg"
			cover
		/>

		<v-card-title
			v-if="noAccessToGroup"
			class="title-text"
		>
			{{ $t('The company does not have access to the selected section') }}
		</v-card-title>

		<v-card-title
			v-else-if="noAccessToReference"
			class="title-text"
		>
			{{ $t('The company does not have access to the selected catalog') }}
		</v-card-title>

		<v-card-title
			v-else
			class="title-text"
		>
			{{ $t('No license') }}
		</v-card-title>

		<v-card-text class="description">
			<div class="subtitle-text">
				{{ $t('To renew your license or open access, please contact your OnTrack manager or support:') }}
			</div>

			<div
				v-if="supportPhone"
				class="support-item"
			>
				<span>{{ $t('Phone') }}:</span>
				<a :href="`tel:${cleanPhone(supportPhone)}`">
					{{ supportPhone }}
				</a>
			</div>

			<div
				v-if="supportEmail"
				class="support-item"
			>
				<span>{{ $t('Email') }}:</span>
				<a :href="`mailto:${supportEmail}`">
					{{ supportEmail }}
				</a>
			</div>
		</v-card-text>
	</v-card>
</template>

<script setup>
// Макросы
defineProps({
	noAccessToGroup: {
		type: Boolean,
		default: false,
	},

	noAccessToReference: {
		type: Boolean,
		default: false,
	},
})

// Данные техподдержки
const supportPhone = import.meta.env.VITE_APP_SUPPORT_PHONE
const supportEmail = import.meta.env.VITE_APP_SUPPORT_EMAIL

const cleanPhone = (phone) => {
	if (!phone) return ''
	return phone.replace(/[^\d+]/g, '')
}
</script>

<style lang="scss">
.app-company-no-license-card {
	width: 80vw;
	max-width: 446px;

	.title-text {
		display: block;
		font-size: 1.5rem;
		font-weight: 500;
		line-height: 1.3;
		padding: 24px 16px 8px;
		color: #111827;
	}

	.description {
		padding: 0 24px 24px;
		font-size: 0.875rem;
		line-height: 1.5;
		color: #4b5563;

		.subtitle-text {
			margin-bottom: 24px;
		}

		.support-item {
			font-size: 1.125rem;
			margin-bottom: 12px;
			color: #111827;

			span {
				font-weight: 400;
				margin-right: 4px;
			}

			a {
				font-size: 1.125rem;
				font-weight: 400;
				text-decoration: none;
				color: rgb(var(--v-theme-primary));
				transition: opacity 0.2s ease;

				&:hover {
					opacity: 0.8;
				}
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
